import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GeneralAdminService } from '../../admin/state';
import { getCookie, setCookie } from '../../core/utils';
import { AdminHeaderComponent } from '../admin-header/admin-header.component';

@Component({
  selector: 'sparrow-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AdminHeaderComponent, RouterOutlet],
})
export class AdminLayoutComponent implements OnInit {
  constructor(private generalAdminService: GeneralAdminService) {}

  ngOnInit() {
    this.generalAdminService.setOrganisations();
    this.generalAdminService.getUnitOfMeasure().subscribe();
    this.generalAdminService.getCurrencies().subscribe();

    if (getCookie('SPARROW_USE_LANGUAGE') !== 'en') {
      setCookie('SPARROW_USE_LANGUAGE', 'en', 99999999);
      location.reload();
    }
  }
}
